/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type RightSide_data = {
    readonly company: {
        readonly customisation: {
            readonly applicationLogo: string | null;
        } | null;
    } | null;
    readonly privileges: {
        readonly menus: ReadonlyArray<{
            readonly nodeName: string;
        } | null> | null;
    } | null;
    readonly " $refType": "RightSide_data";
};
export type RightSide_data$data = RightSide_data;
export type RightSide_data$key = {
    readonly " $data"?: RightSide_data$data;
    readonly " $fragmentRefs": FragmentRefs<"RightSide_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RightSide_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyProfile",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyCustomisation",
          "kind": "LinkedField",
          "name": "customisation",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "applicationLogo",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserPrivileges",
      "kind": "LinkedField",
      "name": "privileges",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PrivilegeMenu",
          "kind": "LinkedField",
          "name": "menus",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "nodeName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
(node as any).hash = '2bf283797bc42da7fcf51f1d5363dac4';
export default node;
